import React, { useEffect, useState } from 'react';
import PopupNotification from './PopupNotification';
import { Form, Button, DatePicker } from 'antd';
import CircularProgress from '@mui/material/CircularProgress';
import axios from 'axios';
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { useDispatch } from 'react-redux';
import { setLoading } from '../store/feedback';
import moment from 'moment';
import dayjs from 'dayjs';
import './auditCreation.css';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './createAudit.css';
import {
  StyledInput,
  StyledSelect,
} from '../login-module/customComponents/styled_input';
import { useNavigate } from 'react-router-dom';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { v4 as uuidv4 } from 'uuid';
import { useParams } from 'react-router-dom';
import CancelIcon from "@mui/icons-material/Cancel";

import { useLocation } from "react-router-dom";
import CaseDetailsHeader from './inspection-mode/CaseDetailsHeader.';
import customParseFormat from "dayjs/plugin/customParseFormat";
dayjs.extend(customParseFormat);

const PrefDeathForm = (props) => {
  const theme = createTheme({
    components: {
      MuiInputBase: {
        styleOverrides: {
          root: {
            fontSize: '16px',
          },
        },
      },
    },
  });
const ValidationIcon = ({ state }) => {
  if (state === null) return null;

  const common = {
    position: "absolute",
    top: 6,
    right: 6,
    fontSize: 16,
    zIndex: 9999,
    pointerEvents: "none",
    background: "white",
    borderRadius: "50%",
  };

  return state ? (
    <CheckCircleIcon style={{ ...common, color: "#16a34a" }} />
  ) : (
    <CancelIcon style={{ ...common, color: "#dc2626" }} />
  );
};
                 


const [originalGroup, setOriginalGroup] = useState(null);
const [groupValidationState, setGroupValidationState] = useState(null); 
// null | true | false
const [muzzleRemark, setMuzzleRemark] = useState("");
  const [birthDate, setBirthDate] = useState(null);
  const dispatch = useDispatch();
  const [popupVisible, setPopupVisible] = useState(false);
  const [popupMessage, setPopupMessage] = useState('');
  const [caseDetails, setCaseDetails] = useState({});
  const [loading, setLoadingState] = useState(false);
  const [form] = Form.useForm();
  const [userId, setUserId] = useState(null);
  const [isFormValid, setIsFormValid] = useState(false);
const location = useLocation();
const { claim_id, eartag, mpcs, dod } = useParams();
console.log(claim_id,eartag,mpcs,dod)
useEffect(() => {
  const prefill = async () => {
    try {
      // 1) from params
      const initial = {
        "Tag No.": eartag || "",
        "Update Location": "",         // will come from DB (address)
        "MPCS/ VET": mpcs,     // will come from DB (phone_no)
        "Beneficiary Name": "",
        "Aadhar No.": "",
        "Date of Death": dod ? dayjs(dod).format("DD-MM-YYYY") : "",
        "Date of Intimation": "",
         "phone_no": "",   
      };

      setCaseDetails(prev => ({ ...prev, ...initial }));
      form.setFieldsValue(initial);

     const res = await axios.post("/process_data/form-prefill", {
        claim_id,
        eartag, // optional; ok to send
      });


      const d = res.data?.data || {};
     setOriginalGroup({
  owner_name: d.validation_source?.owner_name || "",
  adhaar_no: d.validation_source?.adhaar_no || "",
  ear_tag_no: d.validation_source?.ear_tag_no || "",
});
setMuzzleRemark(d.muzzleRemark || "");

const leadRaw = d.lead_creation_time || "";
const lead = leadRaw
  ? dayjs(leadRaw, ["DD-MM-YYYY HH:mm", "DD-MM-YYYY"], true)
  : null;


  //     const lead = d.lead_creation_time
  // ? dayjs(d.lead_creation_time, "DD-MM-YYYY HH:mm", true)
  // : null;
      const mapped = {
        "Beneficiary Name": d.beneficiary_name || "",
         "Aadhar No.": d.aadhar_no || "",
        "Update Location": d.location || "",
        "MPCS/ VET": mpcs || "",
        "phone_no": d.phone_no || "",
        "Tag No.": eartag || "",
        "Date of Death": d.date_of_death ? dayjs(d.date_of_death).format("DD-MM-YYYY") : initial["Date of Death"],
       "Date of Intimation": lead?.isValid()
    ? lead.format("DD-MM-YYYY")
    : initial["Date of Intimation"],};

      setCaseDetails(prev => ({ ...prev, ...mapped }));
      form.setFieldsValue(mapped);
    } catch (err) {
      console.error("Prefill failed:", err);
    }
  };

  if (eartag) prefill();
}, [eartag]);
useEffect(() => {
  if (!originalGroup) return;

  const norm = (v) => (v ?? "").toString().trim().toLowerCase();

  const currentName = caseDetails["Beneficiary Name"];
  const currentAadhar = caseDetails["Aadhar No."];
  const currentTag = caseDetails["Tag No."];

  // If fields not filled yet → no icon
  if (!currentName || !currentAadhar || !currentTag) {
    setGroupValidationState(null);
    return;
  }

  const match_owner =
    norm(currentName) === norm(originalGroup.owner_name);

  const match_aadhaar =
    norm(currentAadhar) === norm(originalGroup.adhaar_no);

  const match_tag =
    norm(currentTag) === norm(originalGroup.ear_tag_no);

  setGroupValidationState(match_owner && match_aadhaar && match_tag);

}, [
  caseDetails["Beneficiary Name"],
  caseDetails["Aadhar No."],
  caseDetails["Tag No."],
  originalGroup
]);


// useEffect(() => {
//   const prefill = async () => {
//     try {
//       // 1) Prefill immediately from navigation state (if available)
//       const n av = location.state || {};

//       const initial = {
//         "Beneficiary Name": nav.farmerName || '',
//         "Aadhar No.": nav.adhaar || '',
//         "Update Location": nav.location || '',
//         "MPCS/ VET": nav.phone || '',
//         "Tag No.": nav.eartag || '',
//         "Date of Death": '',
//         "Date of Intimation": '',
//       };

//       // apply navigation state first
//       setCaseDetails(prev => ({ ...prev, ...initial }));
//       form.setFieldsValue(initial);

//       // 2) Fetch full prefill from backend (works on refresh too)
//       const d = res.data?.data || {};

//       const mapped = {
//         "Beneficiary Name": d.farmerName || nav.farmerName || '',
//         "Aadhar No.": d.adhaar || nav.adhaar || '',
//         "Update Location": d.location || nav.location || '',
//         "MPCS/ VET": d.phone || nav.phone || '',
//         "Tag No.": d.eartag || nav.eartag || '',
//         "Date of Death": d.date_of_death || '',
//         "Date of Intimation": d.date_of_intimation || '',
//       };

//       setCaseDetails(prev => ({ ...prev, ...mapped }));
//       form.setFieldsValue(mapped);
//     } catch (err) {
//       console.error("Prefill failed:", err);
//     }
//   };



console.log("PARAMS:", useParams());
console.log("PATH:", window.location.pathname);
console.log("STATE:", location.state);

  const generateRandomNDigitString = (n) => {
    const uuid = uuidv4().replace(/-/g, '');
    return uuid.substring(0, n).toUpperCase();
  };

  const generateRandomId = () => {
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
    let result = '';
    for (let i = 0; i < 4; i++) {
      const randomIndex = Math.floor(Math.random() * characters.length);
      result += characters[randomIndex];
    }
    const now = new Date();
    const day = now.getDate().toString().padStart(2, '0');
    const hours = now.getHours().toString().padStart(2, '0');
    const mins = now.getMinutes().toString().padStart(2, '0');
    const secs = now.getSeconds().toString().padStart(2, '0');
    const dateTimePart = day + hours + mins + secs;
    result += dateTimePart;
    return result.slice(0, 12);
  };

  useEffect(() => {
    const uuid = generateRandomNDigitString(10);
    setUserId(uuid);
  }, []);

useEffect(() => {
  if (!userId) return;

  const cachedCompanies = localStorage.getItem('insuranceUser');
  const company = cachedCompanies ? JSON.parse(cachedCompanies).company : '';

  setCaseDetails(prev => ({
    ...prev,
    "User Id": userId,
  }));

}, [userId]);

  const handleInputChange = (type, e) => {
    // supports being called with an event or direct value (defensive)
    const value = e && e.target !== undefined ? e.target.value : e;
    setCaseDetails((prevDetails) => ({
      ...prevDetails,
      [type]: value,
    }));
  };

  const handleDateChange = (type, date) => {
    // AntD DatePicker might give a moment; convert to dayjs
    const d = date ? dayjs(date).format('DD-MM-YYYY') : null;
    setCaseDetails((prevDetails) => ({
      ...prevDetails,
      [type]: d,
    }));
  };

  const validateForm = () => {
    const requiredFields = [
      'Beneficiary Name',
      'Aadhar No.',
      'Update Location',
      'MPCS/ VET',
      'Tag No.',
      'Date of Death',
      'Date of Intimation',
    ];

    // every required field must be present and not blank
    const allPresent = requiredFields.every((field) => {
      const val = caseDetails[field];

      if (val === null || val === undefined) return false;
      // for objects or arrays, consider them valid if not empty
      if (typeof val === 'object') {
        try {
          return Object.keys(val).length > 0;
        } catch (e) {
          return !!val;
        }
      }
      return val.toString().trim() !== '';
    });

    return allPresent;
  };

  useEffect(() => {
    setIsFormValid(validateForm());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [caseDetails]);

  const insuranceUser = (() => {
    try {
      return JSON.parse(localStorage.getItem('insuranceUser'));
    } catch (e) {
      return null;
    }
  })();
  const user_Id = insuranceUser?.userId;
  const insuranceConfig = (() => {
    try {
      return JSON.parse(localStorage.getItem('inspectionConfig'));
    } catch (e) {
      return null;
    }
  })();
  
const onFinish = async () => {

  setLoadingState(true);
  dispatch(setLoading(true));

  try {
    // ✅ Save user-entered values so next open prefills
   const resp = await axios.post("/process_data/edit-form-fields", {
      
      // beneficiary_name: caseDetails["Beneficiary Name"],
      // aadhar_no: caseDetails["Aadhar No."],
      // update_location: caseDetails["Update Location"],
      // mpcs_vet_phone: caseDetails["MPCS/ VET"],
      // tag_no: caseDetails["Tag No."],
      // date_of_death: caseDetails["Date of Death"],
      // date_of_intimation: caseDetails["Date of Intimation"],
        claim_id,
  eartag: caseDetails["Tag No."],
  phone_no: caseDetails["phone_no"],
  beneficiary_name: caseDetails["Beneficiary Name"],
  aadhar_no: caseDetails["Aadhar No."],
  update_location: caseDetails["Update Location"],
  mpcs: caseDetails["MPCS/ VET"],
  date_of_death: caseDetails["Date of Death"],
  date_of_intimation: caseDetails["Date of Intimation"],
    });
    console.log("SAVE RESPONSE ✅", resp.data);

    // then continue your existing flow...
    // await axios.post('/create_audit/get_token', ...)
    // uploads...
    navigate('/auditList');
  } catch (err) {
    console.error(err);
  } finally {
    setLoadingState(false);
    dispatch(setLoading(false));
  }
};

  const navigate = useNavigate();

  return (
    <ThemeProvider theme={theme}>
      <div style={{ 
      height: "100vh",
    overflow: "hidden",   
    display: "flex",}}>
        <style jsx>
          {`
            .input-lowercase::placeholder {
              text-transform: capitalize;
            }
          `}
        </style>

        <div
          className="responsive-form-container"
          style={{
            flex: 1,
            overflowY: 'auto',
            display: 'flex',
            flexDirection: 'column',
            gap: '16px',
             minHeight: 0,  
          }}
        >
          {loading && (
            <div
              style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                backgroundColor: 'rgba(0, 0, 0, 0.3)',
                zIndex: 10,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <CircularProgress size={40} sx={{ color: '#FC350B' }} />
            </div>
          )}

          <PopupNotification visible={popupVisible} message={popupMessage} onClose={() => setPopupVisible(false)} />
           
           <CaseDetailsHeader/>
          <div className="form-data">
            <div className="audit-details-group" style={{ width: '80vw' }}>
              {/* Beneficiary Name */}
              <div className="input-wrapper">
                <Form.Item
                  name="Beneficiary Name"
                  rules={[{ required: true, message: "Please enter Beneficiary Name" }]}
                >
                  <div style={{ position: 'relative' }}>
                     <ValidationIcon state={groupValidationState} />

                    <StyledInput
                      value={caseDetails["Beneficiary Name"]}
                      style={{ width: 200 ,paddingRight: 26}}
                      placeholder=" "
                      onChange={e => handleInputChange("Beneficiary Name", e)}
                    />
                    <span className={caseDetails["Beneficiary Name"] ? 'fill' : 'unfilled'}>
                      Beneficiary Name
                    </span>
                  </div>
                </Form.Item>
              </div>

              {/* Aadhar No. */}
              <div className="input-wrapper">
                <Form.Item
                  name="Aadhar No."
                  rules={[
                    { required: true, message: 'Please enter Aadhar No.' },
                    { pattern: /^\d{12}$/, message: 'Aadhar No. must be 12 digits' }
                  ]}
                >
                  <div style={{ position: 'relative' }}>
                    <ValidationIcon state={groupValidationState} />

                    <StyledInput
                      value={caseDetails['Aadhar No.']}
                      style={{ width: 200 ,paddingRight: 26}}
                      placeholder=" "
                      maxLength={12}
                      onChange={e => handleInputChange('Aadhar No.', e)}
                    />
                    <span className={caseDetails['Aadhar No.'] ? 'fill' : 'unfilled'}>
                      Aadhar No.
                    </span>
                  </div>
                </Form.Item>
              </div>

              {/* Update Location */}
              <div className="input-wrapper">
                <Form.Item
                  name="Update Location"
                  rules={[{ required: true, message: "Please enter Update Location" }]}
                >
                  <div style={{ position: 'relative' }}>
                    <StyledInput
                      value={caseDetails["Update Location"]}
                      style={{ width: 200 }}
                      placeholder=" "
                      onChange={e => handleInputChange("Update Location", e)}
                    />
                    <span className={caseDetails["Update Location"] ? 'fill' : 'unfilled'}>
                      Update Location
                    </span>
                  </div>
                </Form.Item>
              </div>

              {/* MPCS/ VET */}
              <div className="input-wrapper">
                <Form.Item
                  name="MPCS/ VET"
                  rules={[
                    { required: true, message: 'Please enter Phone no.' },
                    { pattern: /^\d{10}$/, message: 'Phone no. must be 10 digits' }
                  ]}
                >
                  <div style={{ position: 'relative' }}>
                    <StyledInput
                       value={caseDetails["MPCS/ VET"] || ""}
                      style={{ width: 200 }}
                      placeholder=" "
                      maxLength={10}
                      onChange={(e) => handleInputChange('MPCS/ VET', e)}
                    />
                    <span className={caseDetails['MPCS/ VET'] ? 'fill' : 'unfilled'}>
                      MPCS/ VET
                    </span>
                  </div>
                </Form.Item>
              </div>


                  <div className="input-wrapper">
                <Form.Item
                  name="phone_no"
                  rules={[
                    { required: true, message: 'Please enter Phone no.' },
                    { pattern: /^\d{10}$/, message: 'Phone no. must be 10 digits' }
                  ]}
                >
                  <div style={{ position: 'relative' }}>
                    <StyledInput
                       value={caseDetails["phone_no"] || ""}
                      style={{ width: 200 }}
                      placeholder=" "
                      maxLength={10}
                      onChange={(e) => handleInputChange('phone_no', e)}
                    />
                    <span className={caseDetails['phone_no'] ? 'fill' : 'unfilled'}>
                      Phone No.
                    </span>
                  </div>
                </Form.Item>
              </div>
        <h2
  style={{
    color:
      muzzleRemark === "Muzzle ID is found in Database"
        ? "#28a745"
        : muzzleRemark === "Muzzle ID is not found in Database"
        ? "#dc3545"
        : "#333",
    fontWeight: "260",
    fontSize: "10px",
    marginLeft: "20px",
    marginTop: "10px",
    letterSpacing: "0.5px",
    transition: "color 0.3s ease",
    fontFamily: "'Segoe UI', Roboto, sans-serif"
  }}
>
  {muzzleRemark}
</h2>
             
              {/* Tag No. */}
              <div className="input-wrapper">
                <Form.Item
                  name="Tag No."
                  rules={[{ required: true, message: 'Please enter Tag No.' }]}
                >
                  <div style={{ position: 'relative' }}>
                     <ValidationIcon state={groupValidationState} />


                    <StyledInput
                      value={caseDetails["Tag No."] || ""}
                      style={{ width: 200, paddingRight: 26  }}
                      placeholder=" "
                      onChange={e => handleInputChange('Tag No.', e)}
                    />
                    <span className={caseDetails['Tag No.'] ? 'fill' : 'unfilled'}>
                      Tag No.
                    </span>
                  </div>
                </Form.Item>
              </div>

              {/* Date of Death */}
              <div className="input-wrapper">
                <Form.Item
                  name="Date of Death"
                  rules={[{ required: true, message: 'Please select Date of Death' }]}
                >
                  <div style={{ position: 'relative', display: 'flex', alignItems: 'center', gap: 10, flexDirection: 'column' }}>
                   <DatePicker
                value={caseDetails['Date of Death'] ? dayjs(caseDetails['Date of Death'], 'DD-MM-YYYY') : null}
                onChange={(d) => handleDateChange('Date of Death', d)}
                format="DD-MM-YYYY"
              />

                    {caseDetails['Date of Death'] && (
                      <div style={{ marginTop: 4, color: '#555' }}>
                        Date of Death: {dod}
                      </div>
                    )}
                  </div>
                </Form.Item>
              </div>

              {/* Date of Intimation */}
              <div className="input-wrapper">
                <Form.Item
                  name="Date of Intimation"
                  rules={[{ required: true, message: 'Please select Date of Intimation' }]}
                >
                  <div style={{ position: 'relative', display: 'flex', alignItems: 'center', gap: 10, flexDirection: 'column' }}>
                    <DatePicker
                value={caseDetails['Date of Intimation'] ? dayjs(caseDetails['Date of Intimation'], 'DD-MM-YYYY') : null}
                onChange={(d) => handleDateChange('Date of Intimation', d)}
                format="DD-MM-YYYY"
                    />
                    {caseDetails['Date of Intimation'] && (
                      <div style={{ marginTop: 4, color: '#555' }}>
                        Date of Intimation: {caseDetails['Date of Intimation']}
                      </div>
                    )}
                  </div>
                </Form.Item>
              </div>
            </div>

            <div
              style={{
               position: "static",
                bottom: 30,
                padding: '16px',
                textAlign: 'center',
              }}
            >
              <Form.Item style={{ margin: '0px' }}>
                <Button
                  style={{
                    backgroundColor: isFormValid ? '#FC350B' : '#FC350B',
                    color: '#FFFFFF',
                    minHeight: '40px',
                    width: '300px',
                    borderRadius: '2px',
                  }}
                  htmlType="button"
                  className="responsive-button"
                  onClick={onFinish}
                  disabled={!isFormValid}
                >
                  Save
                </Button>
              </Form.Item>    
            </div>
          </div>
        </div>

        <ToastContainer />
      </div>
    </ThemeProvider>
  );
};

export default PrefDeathForm;